import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { HomePage } from './pages/HomePage';
const theme = extendTheme({
  fonts: {
    heading: "'Playfair Display', serif",
    body: "'Lato', sans-serif"
  },
  colors: {
    brand: {
      softPink: '#F4B8C1',
      blush: '#FAE0E4',
      dustyRose: '#C9929D',
      lace: '#F5EDE0',
      charcoal: '#3A3A3A',
      bgLight: '#FFF5F6'
    }
  },
  styles: {
    global: {
      body: {
        color: '#3A3A3A',
        bg: 'white',
        overflowX: 'hidden'
      }
    }
  },
  components: {
    Button: {
      baseStyle: {
        fontFamily: "'Lato', sans-serif",
        fontWeight: 600,
        borderRadius: '24px',
        minH: '48px'
      }
    },
    Input: {
      baseStyle: {
        field: {
          fontFamily: "'Lato', sans-serif"
        }
      }
    }
  }
});
export function App() {
  return <ChakraProvider theme={theme} data-id="element-0">
      <HomePage data-id="element-1" />
    </ChakraProvider>;
}